var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-overview',{attrs:{"id":"product-overview-page","endpoint":"/product/overview/","page-id":"productoverview"}})}
var staticRenderFns = []

export { render, staticRenderFns }